import { Disclosure } from "@headlessui/react";
import { ChevronRight } from "@material-ui/icons";
import { useEffect, useState } from "react";
import { useGetHierarchyActivityHistoryById } from "../hooks/useGetHierarchyActivityHistoryById";
import MaterialTableEmp from "components/tables/MaterialTableEmp";

const HierarchyActivityHistory = ({ hierarchyData }) => {
  const [, setLoading] = useState(true);
  useEffect(() => {
    let timer = setTimeout(() => setLoading(false), 5000);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  const { data: hierarchyActHistoryData } = useGetHierarchyActivityHistoryById(
    hierarchyData?.hierarchyId
  );

  const materialColumns = [
    {
      title: "Activity",
      field: "message",
    },
    { title: "Hierarchy Name", field: "hierarchyName" },
    { title: "Hierarchy Type", field: "hierarchyTypeName", width: "10%" },
    { title: "Business Unit", field: "businessUnitHierarchyName" },
    { title: "Market", field: "marketHierarchyName" },
    { title: "State", field: "stateHierarchyName" },
    { title: "District", field: "districtHierarchyName" },
    { title: "Team", field: "teamHierarchyName" },
    {
      title: "Date",
      field: "createdDate",
      width: "5%",
      render: (rowData) => {
        return (
          rowData.createdDate &&
          new Date(rowData.createdDate).toLocaleDateString() +
            " " +
            new Date(rowData.createdDate).toLocaleTimeString(
              navigator.language,
              {
                hour: "2-digit",
                minute: "2-digit",
              }
            )
        );
      },
    },
  ];

  return (
    <Disclosure defaultOpen>
      {({ open }) => (
        <>
          <div className="m-2 bg-white rounded-lg box-shadow">
            <Disclosure.Button className="disclosureBtn ml-2">
              <ChevronRight
                className={`${
                  open ? "transform rotate-90" : " text-gray-500"
                } text-gray-500 w-5 h-5 `}
              />
              <span className="disclosureLabel ml-2">Activity History</span>
            </Disclosure.Button>
            <Disclosure.Panel className="text-xs  ">
              <div className="w-full p-2 bg-white">
                <div className="overflow-x-auto grid grid-row">
                  <MaterialTableEmp
                    data={hierarchyActHistoryData}
                    columns={materialColumns}
                    options={{
                      pageSize: 3,
                      toolbar: false,
                      showTitle: false,
                      exportButton: false,
                      search: true,
                      headerStyle: {},
                      rowStyle: {},
                    }}
                  />
                </div>
              </div>
            </Disclosure.Panel>
          </div>
        </>
      )}
    </Disclosure>
  );
};

export default HierarchyActivityHistory;
